import React, { Fragment } from 'react';
import Parents from '../ImmediateFamily/parents.js';
import './ImmediateFamilySection.css';
import {
isRtl,
} from '../../library/constants';

class ImmediateFamilySection extends Parents {

  isFlipPanel = true;

  onMobileTouch(nodeObj){
    this.props.fetchAnotherProfile({
      nodeObj,
      crumbDirection: 'forward',
      saveCurNodeCrumb: true,
    });
  }

  hackForMissingBulletRTL(){

    setTimeout(() => {
      if(document.querySelector('.flip-anchor-bullet')) document.querySelector('.flip-anchor-bullet').style.opacity = .9;

      setTimeout(() => {
        if(document.querySelector('.flip-anchor-bullet')) document.querySelector('.flip-anchor-bullet').style.opacity = 1;
      }, 400);

    }, 0);
  }

  componentDidUpdate(){

  }

  componentDidMount(){

    if( isRtl){
      this.hackForMissingBulletRTL();
    }

  }

  render () {


    return (
      <Fragment>
        <div style={{
                width: `100%`,
                height: '30px',
                fontWeight: 'bold',
                fontSize: '15px',
                color: '#636363',
                textDecoration: 'underline',
              }}
        >
          {

              this.noImmediateFamily()

            ?

              null

            :

            this.props.translatedLabels[`Immediate Family`].translatedLabel


          }
        </div>
        <div id="immediateFamilySection"> { this.getImmediateFamilyTableDom() } </div>
      </Fragment>
    );
  }

}


export default ImmediateFamilySection;

